import { UUID } from "angular2-uuid";

export class TimeRangeReference {
  Level: UUID;
  Counter: number = 0;
}
